class CardSlider {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('[data-sc-track]');
    this.prev = section.querySelector('[data-sc-prev]');
    this.next = section.querySelector('[data-sc-next]');

    if (!this.track || !this.prev || !this.next) return;

    this.bindEvents();
    this.update();
  }

  step() {
    const items = this.track.children;
    if (items.length < 2) return this.track.clientWidth;
    return items[1].offsetLeft - items[0].offsetLeft;
  }

  update() {
    const maxScroll = this.track.scrollWidth - this.track.clientWidth - 5;
    this.prev.disabled = this.track.scrollLeft <= 5;
    this.next.disabled = this.track.scrollLeft >= maxScroll;
  }

  bindEvents() {
    this.prev.addEventListener('click', () => {
      this.track.scrollBy({ left: -this.step(), behavior: 'smooth' });
    });

    this.next.addEventListener('click', () => {
      this.track.scrollBy({ left: this.step(), behavior: 'smooth' });
    });

    this.track.addEventListener('scroll', () => this.update(), { passive: true });
    window.addEventListener('resize', () => this.update());
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.slider-cards').forEach(section => {
    new CardSlider(section);
  });
});
